
import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  if (window.properCollectionCartInitialized) return;
  window.properCollectionCartInitialized = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('.proper-ajax-cart-form')
    ) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.adding === 'true') return;

    const button = form.querySelector('.proper-collection-add');
    if (!button) return;

    form.dataset.adding = 'true';
    button.disabled = true;
    button.textContent = 'ADDING...';

    const formData = new FormData(form);
    const variantId = String(formData.get('id') || '');
    const quantity = Number(formData.get('quantity')) || 1;

    const sectionIds = [
      ...new Set(
        Array.from(document.querySelectorAll('cart-items-component'))
          .map(element => element.dataset.sectionId)
          .filter(Boolean)
      )
    ];

    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
    }

    const deferred = CartLinesUpdateEvent.createPromise();

    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{
          merchandiseId: variantId,
          quantity
        }],
        promise: deferred.promise
      })
    );

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description || result.message || 'Unable to add product.'
        );
      }

      const cartResponse = await fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Unable to refresh cart.');
      }

      const cart = await cartResponse.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'proper-collection-cart',
          itemCount: quantity,
          sections: result.sections,
          didError: false
        }
      });

// Use Horizon's original flying-to-cart animation
const cartIcon = document.querySelector('.header-actions__cart-icon');
const productCard = form.closest('product-card');

const productImage = productCard?.querySelector('img');

if (cartIcon && productImage && customElements.get('fly-to-cart')) {
  const flyToCart = document.createElement('fly-to-cart');

  flyToCart.classList.add('fly-to-cart--quick');
  flyToCart.style.setProperty(
    'background-image',
    `url("${productImage.currentSrc || productImage.src}")`
  );
  flyToCart.style.setProperty('--start-opacity', '0');

  flyToCart.source = button;
  flyToCart.destination = cartIcon;

  document.body.appendChild(flyToCart);
}

button.textContent = 'ADDED ✓';

await new Promise(resolve => setTimeout(resolve, 800));

    } catch (error) {
      deferred.reject(error);
      console.error('Collection cart error:', error);
      button.textContent = 'ERROR';
      alert(error.message || 'Unable to add product.');

    } finally {
      button.textContent = 'ADD TO CART';
      button.disabled = false;
      delete form.dataset.adding;
    }
  }, true);
})();
